var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import GoodService from '../../../api/GoodService';
import ClientService from '../../../api/ClientService';
import TabTable from './TabTable.vue';
import _ from 'lodash';
var EActiveType;
(function (EActiveType) {
    EActiveType["UN_SELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
var AddGoods = (function (_super) {
    __extends(AddGoods, _super);
    function AddGoods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shopId = null;
        _this.multiple = false;
        _this.tabTableComponent = 'tab-table';
        _this.tableData = [];
        _this.total = 0;
        _this.pagerCount = 5;
        _this.curGoodNode = {};
        _this.activeName = '0';
        _this.selectRows = [];
        _this.unSelectList = [];
        _this.selectedList = [];
        _this.canFreshTable = true;
        _this.formData = {};
        return _this;
    }
    AddGoods.prototype.created = function () {
        console.log('this.tabTableComponent');
        console.log(this.tabTableComponent);
        this.service = GoodService.getInstance();
        this.ClientService = ClientService.getInstance();
        this.getbindList();
    };
    AddGoods.prototype.mounted = function () {
    };
    AddGoods.prototype.gitRightList = function (pager) {
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
    };
    AddGoods.prototype.getUserList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        console.log(999, this.selectedList);
        var account_ids;
        account_ids = (this.selectedList || []).map(function (item) {
            return item.account_id;
        });
        var params = {
            keyword: this.formData.keyword,
            shop_id: '',
            account_status: 1,
        };
        this.ClientService.getSaleUser(Object.assign({}, params, {
            is_not_in: Array.isArray(account_ids) ? account_ids.join(',') : account_ids
        }, pager)).then(function (res) {
            console.log(777, res.data);
            var AllDate = Array.isArray(res.data.data) ? res.data.data : [];
            AllDate.forEach(function (item) {
                item.is_admin = item.is_admin == '1' ? '管理员' : '子账号';
            });
            _this.total = res.data.total;
            _this.unSelectList = AllDate;
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddGoods.prototype.getbindList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var shopId = this.shopId;
        if (this.shopId && this.multiple) {
            shopId = "";
        }
        var params = {
            keyword: this.formData.keyword,
            shop_id: shopId,
            account_status: 1,
        };
        this.ClientService.getSaleUser(Object.assign({}, params, pager)).then(function (res) {
            var AllDate = Array.isArray(res.data.data) ? res.data.data : [];
            AllDate.forEach(function (item) {
                item.is_admin = item.is_admin == '1' ? '管理员' : '子账号';
            });
            if (_this.shopId && _this.multiple) {
                _this.selectedList = [];
            }
            else {
                _this.selectedList = AllDate;
            }
            _this.getUserList();
            _this.setSelected(true);
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddGoods.prototype.selectChange = function (rows, currentRow, isSelectAll) {
        var _this = this;
        if (isSelectAll === void 0) { isSelectAll = false; }
        if (!this.canFreshTable)
            return;
        this.canFreshTable = false;
        var currentSelectRows = _.filter(rows, function (row) { return !!row; });
        this.selectedList = _.uniqBy(this.selectedList.concat(currentSelectRows), 'account_id');
        var isUnselectAll = !currentSelectRows.length && !currentRow && isSelectAll;
        if (currentRow && !_.find(currentSelectRows, function (account) { return account.account_id === currentRow.account_id; })) {
            _.remove(this.selectedList, function (account) { return account.account_id === currentRow.account_id; });
        }
        else if (isUnselectAll && this.activeName === EActiveType.SELECTED) {
            this.selectedList = [];
        }
        else if (isUnselectAll) {
            this.unSelectList.forEach(function (account) {
                _.remove(_this.selectedList, function (item) { return item.account_id === account.account_id; });
            });
        }
        this.setSelected(this.activeName === EActiveType.SELECTED);
        setTimeout(function () {
            _this.canFreshTable = true;
            var pagination = _this.$refs.pagination;
            _this.getUserList(pagination.getPage());
        });
    };
    AddGoods.prototype.handleClick = function (tab, event) {
        if (tab.name == "second") {
            this.setSelected();
        }
    };
    AddGoods.prototype.setSelected = function (isUnSelFresh) {
        var _this = this;
        if (isUnSelFresh === void 0) { isUnSelFresh = false; }
        var gridTable = this.$refs.grid.$refs.table;
        if (isUnSelFresh) {
            gridTable.clearSelection();
        }
        if (!this.selectedList.length) {
            this.$refs.alreadyGrid.$refs.table.clearSelection();
        }
        else {
            this.selectedList.forEach(function (account, index) {
                _this.$nextTick(function () {
                    _this.$refs.alreadyGrid.$refs.table.toggleRowSelection(account, true);
                });
                if (isUnSelFresh) {
                    var item_1 = _.find(_this.unSelectList, function (current) { return current.account_id === account.account_id; });
                    _this.$nextTick(function () {
                        gridTable.toggleRowSelection(item_1, true);
                    });
                }
            });
        }
    };
    AddGoods.prototype.search = function () {
        var pagination = this.$refs.pagination;
        pagination.clear();
        this.getUserList();
    };
    AddGoods.prototype.close = function () {
        this.$closeDialog();
        this.$emit('closeDiolog', false);
    };
    AddGoods.prototype.save = function () {
        var data = _.uniqBy(this.selectedList, 'account_id');
        var accounts = [];
        data.forEach(function (item) {
            accounts.push(item.account_id);
        });
        var AllData = {
            data: accounts,
            shopId: this.shopId
        };
        this.$closeDialog();
        this.$emit('save:ok', AllData);
    };
    AddGoods.prototype.nodeClick = function (node) {
        this.curGoodNode = node || null;
        this.gitRightList();
    };
    AddGoods.prototype.pageChange = function (pager) {
        this.gitRightList(pager);
        this.$refs.grid.$refs.table.bodyWrapper.scrollTop = 0;
    };
    __decorate([
        Prop({
            type: Object
        })
    ], AddGoods.prototype, "imageItem", void 0);
    AddGoods = __decorate([
        Component({
            components: {
                'tab-table': TabTable,
            }
        })
    ], AddGoods);
    return AddGoods;
}(VueDialog));
export default AddGoods;
